var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavRatesFavoriteOutline18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.375 2.25A4.491 4.491 0 009 3.817 4.491 4.491 0 005.625 2.25 4.085 4.085 0 001.5 6.375c0 2.835 2.55 5.145 6.412 8.655L9 16.012l1.088-.99C13.95 11.52 16.5 9.21 16.5 6.376a4.085 4.085 0 00-4.125-4.125zm-3.3 11.662L9 13.987l-.075-.075C5.355 10.68 3 8.543 3 6.375c0-1.5 1.125-2.625 2.625-2.625 1.155 0 2.28.742 2.678 1.77h1.402c.39-1.027 1.515-1.77 2.67-1.77 1.5 0 2.625 1.125 2.625 2.625 0 2.168-2.355 4.305-5.925 7.537z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavRatesFavoriteOutline18);
export default __webpack_public_path__ + "5a2ace24c40fbcdf4280c5e7f9b4ff77.svg";
export { ForwardRef as ReactComponent };